'use client';
import React, { useEffect, useRef, useState } from "react";
import { Sidebar, SidebarBody, SidebarLink } from "@/components/aceternity/sidebar";
import { Command } from 'cmdk' 
import {
  IconArrowLeft,
  IconBrandTabler,
  IconSettings,
  IconUserBolt,
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconX,
  IconArrowRight,
  IconLayoutNavbarCollapse,
  IconMenu2, 
  IconArrowWaveRightUp,
  IconBoxAlignRightFilled,
  IconBoxAlignTopLeft,
  IconClipboardCopy,
  IconFileBroken,
  IconSignature,
  IconTableColumn,
  IconBrandYoutubeFilled,
  IconAdjustmentsBolt,
  IconCloud,
  IconCurrencyDollar,
  IconEaseInOut,
  IconHeart,
  IconHelp,
  IconRouteAltLeft,
  IconTerminal2,
  IconBrandGithub,
  IconBrandX,
  IconExchange,
  IconHome,
  IconNewSection,
} from "@tabler/icons-react";
import Link from "next/link";
import { motion } from "framer-motion";
import Image from "next/image";
import { cn } from "@/lib/utils";


import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown, ChevronRight, Search } from "lucide-react";


import type { User } from 'next-auth';
import { usePathname, useRouter } from 'next/navigation';

import { PlusIcon } from '@/components/icons';
import { SidebarHistory } from '@/components/sidebar-history';
import { SidebarUserNav } from '@/components/sidebar-user-nav_new';
import { Button } from '@/components/ui/button';
import {
  Sidebar as ASideBar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  useSidebar,
} from '@/components/ui/sidebar';
// import Link from 'next/link';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { CMDKWrapper, Item } from "./ui/raycast";
import { DOCS } from "@/app/(work)/layout-left/left-data/documentation.constant";
// import { DOCS } from "@/ai/back/(work)/layout-novel/documentation.constant";


export function AppSidebar({ user }: { user: User | undefined }) {
  const router = useRouter();
  const { setOpenMobile } = useSidebar();

  return (
    <ASideBar className="group-data-[side=left]:border-r-0">
      <SidebarHeader>
        <SidebarMenu>
          <div className="flex flex-row justify-between items-center">
            <Link
              href="/"
              onClick={() => {
                setOpenMobile(false);
              }}
              className="flex flex-row gap-3 items-center"
            >
              <span className="text-lg font-semibold px-2 hover:bg-muted rounded-md cursor-pointer">
                Imix
              </span>
            </Link>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  type="button"
                  className="p-2 h-fit"
                  onClick={() => {
                    setOpenMobile(false);
                    router.push('/');
                    router.refresh();
                  }}
                >
                  <PlusIcon />
                </Button>
              </TooltipTrigger>
              <TooltipContent align="end">New Chat</TooltipContent>
            </Tooltip>
          </div>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarHistory user={user} />
      </SidebarContent>
      <SidebarFooter>{user && <SidebarUserNav user={user} />}</SidebarFooter>
    </ASideBar>
  );
}


// export function DashSidebar() {
export function DashSidebar({ user }: { user: User | undefined }) {
  // const router = useRouter();
  // const { setOpenMobile } = useSidebar();
  const [value, setValue] = useState('linear')
  const inputRef = useRef<HTMLInputElement | null>(null)
  const listRef = useRef(null)
  const [open, setOpen] = useState(true);

  const pathname = usePathname();
  const [searchTerm, setSearchTerm] = useState("");
  const [openGroups, setOpenGroups] = useState<string[]>(
    DOCS.map((group) => group.phaseKey)
  );

  const navlinks = [
    // { title: "Dev", label: "Dev", href: "/dev", icon: (<IconExchange className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Home", label: "首页", href: "/main", icon: (<IconHome className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Writing", label: "AI 沉浸式创作", href: "/writing", icon: (<IconSignature className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Template", label: "AI 模版专区", href: "/template", icon: (<IconAdjustmentsBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "task", label: "AI 自动化定制", href: "/task", icon: (<IconEaseInOut className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Lecture", label: "AI 精品课堂", href: "/lecture", icon: (<IconClipboardCopy className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Links", label: "AI 网址导航", href: "/links", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
      // { title: "Column", label: "仪表盘", href: "/dashboard", icon: (<IconMenu2 className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  
      { title: "privacy", label: "隐私政策", href: "/dashboard/privacy", 
        // icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)
      },
      { title: "terms-of-user", label: "用户服务", href: "/dashboard/terms-of-user", 
        // icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)
      },
      { title: "copyright", label: "版权政策", href: "/dashboard/copyright", 
        // icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)
      },
      { title: "disclaimer", label: "免责声明", href: "/dashboard/disclaimer", 
        // icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)
      },

      
    ];
  

  const toollinks: any[] = [
    // { title: "FileBroken", label: "AI 小说生成", href: "/novel", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Cloud", label: "AI 自媒体创作", href: "/post", icon: (<IconCloud className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "AltLeft", label: "AI 办公提效", href: "/work", icon: (<IconRouteAltLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "UserBolt", label: "AI 职场辅导", href: "/job", icon: (<IconUserBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Heart", label: "AI 测评指导", href: "/test", icon: (<IconHeart className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Help", label: "AI 提示词生成", href: "/prompt", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Terminal2", label: "AI 指令精选", href: "/command", icon: (<IconTerminal2 className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Main", label: "AI 问答收藏", href: "/answer", icon: (<IconLayoutNavbarCollapse className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    
    
    // { title: "NewSection", label: "AI 图片生成", href: "/pict", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "NewSection", label: "AI 影视创作", href: "/movie", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "NewSection", label: "AI 音乐坊", href: "/movie", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "NewSection", label: "AI 漫画工场", href: "/movie", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},



    // { title: "IconX", label: "IconX", href: "/main", icon: (<IconX className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "ArrowNarrowLeft", label: "ArrowNarrowLeft", href: "/fileBroken", icon: (<IconArrowNarrowLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "ArrowNarrowRight", label: "ArrowNarrowRight", href: "/dev", icon: (<IconArrowNarrowRight className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    //{ title: "Dashboard", label: "Dashboard", href: "/dashboard", icon: (<IconArrowRight className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    //{ title: "Dashboard", label: "Dashboard", href: "/dashboard", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "RightFilled", label: "RightFilled", href: "/dashboard", icon: (<IconBoxAlignRightFilled className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "TopLeft", label: "TopLeft", href: "/dashboard", icon: (<IconBoxAlignTopLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Youtube", label: "Youtube", href: "/dashboard", icon: (<IconBrandYoutubeFilled className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Dollar", label: "Dollar", href: "/dashboard", icon: (<IconCurrencyDollar className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "Github", label: "Github", href: "/dashboard", icon: (<IconBrandGithub className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
    // { title: "BrandX", label: "BrandX", href: "/dashboard", icon: (<IconBrandX className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  ];

  const settingslinks = [
    {
      title: "Profile",
      label: "Profile",
      href: "/profile",
      icon: (
        <IconUserBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />
      ),
    },
    {
      title: "Settings",
      label: "Settings",
      href: "#",
      icon: (
        <IconSettings className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />
      ),
    },
    {
      title: "Logout",
      label: "Logout",
      href: "#",
      icon: (
        <IconArrowLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />
      ),
    },
  ];


    useEffect(() => {
      // Ensure the group of the active link is open
      const activeGroup = DOCS.find((group) =>
        group.phaseTasks.some((child) => child.url === pathname)
      );
      if (activeGroup && !openGroups.includes(activeGroup.phaseKey)) {
        setOpenGroups((prev) => [...prev, activeGroup.phaseKey]);
      }
    }, [pathname]);
  
    const toggleGroup = (phaseKey: string) => {
      setOpenGroups((prev) =>
        prev.includes(phaseKey)
          ? prev.filter((key) => key !== phaseKey)
          : [...prev, phaseKey]
      );
    };
  
    const filteredDocs = DOCS.map((group) => ({
      ...group,
      children: group.phaseTasks
        .filter((child) =>
          child.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => a.label.localeCompare(b.label)),
    })).filter((group) => group.children.length > 0);
  


  return (
    <Sidebar open={open} setOpen={setOpen}>
      <SidebarBody className="flex flex-col h-full">
        <div className="flex flex-col h-full">
          {/* 顶部吸顶区域, 可滚动 */}
          {/* <div className="shrink-0 sticky top-0 z-0 bg-inherit">
            {open ? <Logo /> : <LogoIcon />}
          </div> */}
           <div className="flex-1 overflow-y-auto">
            <CMDKWrapper key="raycast">
            <Command value={value} onValueChange={(v) => setValue(v)}>
              <div cmdk-raycast-top-shine="" />
              {/* <Command.Input  
                //   className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
                className="h-9 w-full rounded-lg border border-zinc-950/10 bg-transparent p-2  placeholder-zinc-500 focus:outline-none"
                //   className="rounded-lg border border-neutral-800 focus:ring-2 focus:ring-teal-500  w-full relative z-10 mt-4  bg-neutral-950 placeholder:text-neutral-700"
                //  className="bg-muted text-md md:text-sm h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
                ref={inputRef} autoFocus placeholder="搜索..." 
              /> */}
              <hr cmdk-raycast-loader="" />
              <Command.List ref={listRef}>
                <Command.Empty>No results found.</Command.Empty>
                <Command.Group className="w-20 text-muted-foreground font-bold font-14 text-sm mt-4" heading="相关协议">
                  <div className="mt-2 flex flex-col gap-2">
                    {navlinks.map((link, idx) => (
                      <Item key={`LinkItem${idx}`} value={link.label} keywords={['issue', 'sprint']}>
                          <SidebarLink key={idx} link={link} />
                      </Item>
                    ))}
                  </div>
                </Command.Group>
                {/* <Command.Group className="w-20 text-muted-foreground font-semibold font-14 text-sm mt-4" heading="工具箱">
                  <div className="mt-2 flex flex-col gap-2">
                    {toollinks.map((link, idx) => (
                      <Item key={link.label + idx} value={link.label} keywords={['issue', 'sprint']}>
                          <SidebarLink key={idx} link={link} />
                      </Item>
                    ))}
                  </div>
                </Command.Group> */}
              </Command.List>
            </Command>
            </CMDKWrapper>
        </div>



          {/* 底部贴底区域 (固定高度) */}
          {/* <div className="shrink-0 sticky bottom-0 z-10 bg-inherit  border-t mt-auto"> */}
          <div className="shrink-0 sticky bottom-0 z-10  bg-gray-100 dark:bg-neutral-800 border-t mt-auto">
            {/* 中间内容 */}
            {/* <div className="flex-1 overflow-y-auto overflow-x-hidden">
              <div className="mt-8 flex flex-col gap-2">
                {settingslinks.map((link, idx) => (
                  <SidebarLink key={idx} link={link} />
                ))}
              </div>
            </div> */}

            {/* <SidebarLink
              link={{
                label: "LargeX",
                href: "#",
                icon: (
                  <Image
                     src="/images/sun.png"
                    className="h-7 w-7 shrink-0 rounded-full"
                    width={50}
                    height={50}
                    alt="Avatar"
                  />
                ),
              }}
            /> */}


          </div>
        </div>
      </SidebarBody>
    </Sidebar>
  );
}


export const Logo = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm shrink-0" />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-medium text-black dark:text-white whitespace-pre"
      >
        AIGex
      </motion.span>
    </Link>
  );
};

export const LogoIcon = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm shrink-0" />
    </Link>
  );
};
